export default __webpack_public_path__ + "static/media/profile.b2386cf0.jpg";